// extracted by mini-css-extract-plugin
export default {"container":"ControlPanel_container__5wJlJ","titleContainer":"ControlPanel_titleContainer__2DjN6","text_left":"ControlPanel_text_left__TLMer"};